/* eslint-disable react/no-danger */
import React from 'react';
import './Stepper.scss';

export interface Type {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
}

const Stepper = function init(props: Type): React.ReactElement {
  const { content } = props;

  return (
    <div className="root-container">
      {content.map((item, index) => {
        const isLastIndex = index === content.length - 1;
        return (
          <div className="stepper-container">
            <div className="left-container">
              <div className="round-number">{index + 1}</div>
              <div className={isLastIndex ? "zero-opacity" : "separator"} />
            </div>
            <div className="right-container" dangerouslySetInnerHTML={{ __html: item }} />
          </div>
        );
      })}
      <div className="break-line" />
    </div>
  );
};

export default Stepper;
